import { render, staticRenderFns } from "./ConfirmButton.vue?vue&type=template&id=2d1fd8f2&"
import script from "./ConfirmButton.vue?vue&type=script&lang=ts&"
export * from "./ConfirmButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sush/Virtual/cublic-form-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d1fd8f2')) {
      api.createRecord('2d1fd8f2', component.options)
    } else {
      api.reload('2d1fd8f2', component.options)
    }
    module.hot.accept("./ConfirmButton.vue?vue&type=template&id=2d1fd8f2&", function () {
      api.rerender('2d1fd8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resource/component/form/Field/ConfirmButton.vue"
export default component.exports